export default __webpack_public_path__ + "assets/icons/my.f61e387c.svg";